import { TFieldsToRecalculateMap } from '../../models/financialTable/fieldsToRecalculate'

export const fieldsToRecalculateYoY: TFieldsToRecalculateMap = {
  PrevYearQ1ActualsSob: {
    prevValue: 'PrevPrevYearQ1ActualsSob',
    fieldToChange: 'PrevYearQ1YoYActualsSob',
    additionalRecalc: 'CurrentYearQ1ActualsSob',
    yearField: 'PrevYearFYActualsSob',
  },
  PrevYearQ2ActualsSob: {
    prevValue: 'PrevPrevYearQ2ActualsSob',
    fieldToChange: 'PrevYearQ2YoYActualsSob',
    additionalRecalc: 'CurrentYearQ2ActualsSob',
    yearField: 'PrevYearFYActualsSob',
  },
  PrevYearQ3ActualsSob: {
    prevValue: 'PrevPrevYearQ3ActualsSob',
    fieldToChange: 'PrevYearQ3YoYActualsSob',
    additionalRecalc: 'CurrentYearQ3ActualsSob',
    yearField: 'PrevYearFYActualsSob',
  },
  PrevYearQ4ActualsSob: {
    prevValue: 'PrevPrevYearQ4ActualsSob',
    fieldToChange: 'PrevYearQ4YoYActualsSob',
    additionalRecalc: 'CurrentYearQ4ActualsSob',
    yearField: 'PrevYearFYActualsSob',
  },
  CurrentYearQ1ActualsSob: {
    prevValue: 'PrevYearQ1ActualsSob',
    fieldToChange: 'CurrentYearQ1YoYActualsSob',
    yearField: 'CurrentYearFYActualsSob',
  },
  CurrentYearQ2ActualsSob: {
    prevValue: 'PrevYearQ2ActualsSob',
    fieldToChange: 'CurrentYearQ2YoYActualsSob',
    yearField: 'CurrentYearFYActualsSob',
  },
  CurrentYearQ3ActualsSob: {
    prevValue: 'PrevYearQ3ActualsSob',
    fieldToChange: 'CurrentYearQ3YoYActualsSob',
    yearField: 'CurrentYearFYActualsSob',
  },
  CurrentYearQ4ActualsSob: {
    prevValue: 'PrevYearQ4ActualsSob',
    fieldToChange: 'CurrentYearQ4YoYActualsSob',
    yearField: 'CurrentYearFYActualsSob',
  },
  CurrentYearFYActualsSob: {
    prevValue: 'PrevYearFYActualsSob',
    fieldToChange: 'CurrentYearFYYoYActualsSob',
  },
  CurrentYearFYActuals: {
    prevValue: 'PrevYearFYActuals',
    fieldToChange: 'CurrentYearFYYoYActuals',
  },
  PrevYearFYActualsSob: {
    prevValue: 'PrevPrevYearFYActualsSob',
    fieldToChange: 'PrevYearFYYoYActualsSob',
  },
  PrevYearFYActuals: {
    prevValue: 'PrevPrevYearFYActuals',
    fieldToChange: 'PrevYearFYYoYActuals',
  },
}

export const fieldsToRecalculateQoQ: TFieldsToRecalculateMap = {
  PrevYearQ1ActualsSob: {
    prevValue: 'PrevPrevYearQ4ActualsSob',
    fieldToChange: 'PrevYearQ1QoQActualsSob',
    additionalRecalc: 'CurrentYearQ1ActualsSob',
    yearField: 'PrevYearFYActualsSob',
  },

  PrevYearQ2ActualsSob: {
    prevValue: 'PrevYearQ1ActualsSob',
    fieldToChange: 'PrevYearQ2QoQActualsSob',
    additionalRecalc: 'CurrentYearQ2ActualsSob',
    yearField: 'PrevYearFYActualsSob',
  },

  PrevYearQ3ActualsSob: {
    prevValue: 'PrevYearQ2ActualsSob',
    fieldToChange: 'PrevYearQ3QoQActualsSob',
    additionalRecalc: 'CurrentYearQ3ActualsSob',
    yearField: 'PrevYearFYActualsSob',
  },

  PrevYearQ4ActualsSob: {
    prevValue: 'PrevYearQ3ActualsSob',
    fieldToChange: 'PrevYearQ4QoQActualsSob',
    additionalRecalc: 'CurrentYearQ4ActualsSob',
    yearField: 'PrevYearFYActualsSob',
  },

  CurrentYearQ1ActualsSob: {
    prevValue: 'PrevYearQ4ActualsSob',
    fieldToChange: 'CurrentYearQ1QoQActualsSob',
    yearField: 'CurrentYearFYActualsSob',
  },

  CurrentYearQ2ActualsSob: {
    prevValue: 'CurrentYearQ1ActualsSob',
    fieldToChange: 'CurrentYearQ2QoQActualsSob',
    yearField: 'CurrentYearFYActualsSob',
  },

  CurrentYearQ3ActualsSob: {
    prevValue: 'CurrentYearQ2ActualsSob',
    fieldToChange: 'CurrentYearQ3QoQActualsSob',
    yearField: 'CurrentYearFYActualsSob',
  },

  CurrentYearQ4ActualsSob: {
    prevValue: 'CurrentYearQ3ActualsSob',
    fieldToChange: 'CurrentYearQ4QoQActualsSob',
    yearField: 'CurrentYearFYActualsSob',
  },
}
